import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, MarginBox, Text } from 'UI';
import { textFormatter } from 'utils';

const TotalMarginLine = ({
  currency,
  totalMargin,
  totalMarginPercentage,
}: {
  currency?: string;
  totalMargin?: number;
  totalMarginPercentage?: string;
}) => {
  const { t } = useTranslation();
  const totalMarginFormatted = textFormatter.formatCurrency(totalMargin || 0.0, currency);

  return (
    <Flex>
      <Flex size={4}>
        <Text type="base" bold>
          {t('common.total_margin', 'Total margin')}
        </Text>
      </Flex>
      <Flex />
      <Flex size={6}>
        <Flex justify={'flex-end'}>
          <Text type="base">
            {t('common.price.vat_exclude_price', '{{vat_exclude_price}} VAT. Excl', {
              vat_exclude_price: totalMarginFormatted,
            })}
          </Text>
        </Flex>
      </Flex>
      <MarginBox mr={30} />
      <Flex size={4}>
        <Flex justify={'flex-start'} />
        <Flex justify={'flex-end'}>
          <Text type="base">{totalMarginPercentage + '%'}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TotalMarginLine;
